import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KenButton from '../KenButton';

export function ErrorFallback({ error, resetErrorBoundary }) {
  // Log the underlying error so we can diagnose prerender failures (e.g., react-snap runs).
  if (error) {
    // eslint-disable-next-line no-console
    console.error('Application error captured by ErrorBoundary', error?.stack || error);
  }
  return (
    <Box role="alert" alignItems="center" justifyContent="center" display="flex" flexDirection="column">
      <Typography style={{ marginTop: 10 }}>Something went wrong</Typography>
      <KenButton onClick={resetErrorBoundary}>Click here to Refresh</KenButton>
    </Box>
  );
}
